export type Loading = {
  count: number,
  message: string | null
}

export type LoadingState = {
  [key: string]: Loading
}

export enum LoaderAction {
  ADDING_TIME_LOADING = 'ADDING_TIME_LOADING',
  SUB_TIME_LOADING = 'SUB_TIME_LOADING',
  CHANGE_MESSAGE_LOADING = 'CHANGE_MESSAGE_LOADING'
}

interface AddingTimeLoadingType {
  type: LoaderAction.ADDING_TIME_LOADING;
  scope: string
}

interface SubTimeLoadingType {
  type: LoaderAction.SUB_TIME_LOADING;
  scope: string
}

interface ChangeMessageLoadingType {
  type: LoaderAction.CHANGE_MESSAGE_LOADING;
  scope: string,
  message: string
}

export type LoaderActionTypes = AddingTimeLoadingType | SubTimeLoadingType | ChangeMessageLoadingType;
